export enum CondicaoPagamentoModoEnum {
    IntervaloUnico = 1,
    DiasPorParcela = 2
}
